import React, { Fragment, useEffect, useState } from "react";
import {
  Container,
  FormControl,
  Nav,
  Navbar,
  NavDropdown,
} from "react-bootstrap";

import shoppingCart from "../../Images/shopping-cart.png";
import user from "../../Images/user.png";
import { useTranslation } from "react-i18next";
import cookies from "js-cookie";
import NavBarSearchHook from "../../hook/search/NavBarSearchHook";
import UserCartHook from "../../hook/cart/UserCartHook";
import ReactGA from "react-ga";
import GetConfigDataHook from "../../hook/configer/GetConfigDataHook";
import { BsQuestionCircleFill, BsSearch } from "react-icons/bs";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Link, NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { notLoginAddItemToCart } from "../../redux/actions/cartAction";


const NavBarLogin = () => {
  const [onChangeSearch, searchWord, setSearchWord, homeCategories, pagination, selectCategoryState, setSelectCategoryState, settingsRes, selectedVendor, setSelectedVendor] = NavBarSearchHook();
  const [webSiteData, settings] = GetConfigDataHook();
  const location = useLocation();
  const dispatch = useDispatch();

  const vendors = useSelector((state) => state.usersReducers.allVendors);

  // const settingsRes = useSelector((state) => state.settingsReducers.settings);

  console.log('vendors', vendors);

  const languages = [
    {
      code: "en",
      name: "English",
      dir: "ltr",
    },
    {
      code: "ar",
      name: "العربية",
      dir: "rtl",
    },
  ];
  const [t, i18n] = useTranslation();
  const currentLanguageCode = cookies.get("i18next") || "en";
  const currentLanguage = languages.find((l) => l.code === currentLanguageCode);


  const handleGoogleEvent = () => {
    ReactGA.event({
      category: "cart",
      action: "cart_details_action",
      label: "cart_label",
    });
  };

  useEffect(() => {
    // var titleAr = settingsRes?.data?.titleAr
    // document.title = titleAr ? titleAr : ''
    document.body.dir = currentLanguage.dir || "ltr";
  }, [currentLanguage]);
  // let word = "";
  // if (localStorage.getItem("searchWord") != null) {
  //   word = localStorage.getItem("searchWord");
  // }
  const [userData, setUserData] = useState("");

  useEffect(() => {
    if (localStorage.getItem("user") != null) {
      setUserData(JSON.parse(localStorage.getItem("user")));
    }

    // في حالة not login عشان تعرض عدد المنتجات الل ف السلة
    let prevCart = JSON.parse(localStorage.getItem("cart"));

    console.log('prevCart in navbar', prevCart);

    if (prevCart?.length) {
      dispatch(notLoginAddItemToCart({ numberOfItems: prevCart?.length }));
      // localStorage.setItem("cart", JSON.stringify([]));
    }
  }, []);

  const logOut = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("page");
    localStorage.removeItem("token");

    setUserData("");
  };
  const [res] = UserCartHook();
  const notLoginNumberOfCartItems = useSelector((state) => state.cartReducer.notLoginCartNumberOfItems);

  console.log('notLoginNumberOfCartItems', notLoginNumberOfCartItems);

  // console.log(res?.numberOfCart)
  // console.log(useSelector((state) => state.cartReducer.userCartItems));
  const navigate = useNavigate()
  const navProduct = () => {
    navigate('/admin/products')
  }

  const navLogout = () => {
    navigate('/admin/products')

  }


  return (
    <Navbar
      className="sticky-top noon-navbar"
      expand="md"
    >
      <Container fluid className="px-2 px-lg-4 d-flex align-items-center justify-content-between" style={{ gap: "1rem" }}>
        <Navbar.Brand>
          <Link to="/">
            <img alt="Logo" onClick={() => {
              setSelectCategoryState('');
              setSelectedVendor('');
              setSearchWord('');
            }} src={settings?.data?.logo} className="logo" />
          </Link>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">



        {/* Noon Search Container */}
        <div className="noon-search-container mt-3 mt-md-0 mx-0 mx-md-4 d-flex">
          <select
            id="categories"
            className="first-search-input"
            onChange={(e) => setSelectCategoryState(e.target.value)}
            value={selectCategoryState}
          >
            <option value=''>{t('All Categories')}</option>
            {homeCategories && homeCategories?.map(category =>
              <option key={category._id} value={category._id}>{currentLanguageCode === 'ar' ? category.nameAr : category.nameEn}</option>
            )}
          </select>

          <FormControl
            onChange={(e) => setSearchWord(e.target.value)}
            value={searchWord}
            type="search"
            placeholder={currentLanguageCode === 'ar' ? "ما الذي تبحث عنه؟" : "What are you looking for?"}
            className="form-control"
            aria-label="Search"
            id="navbarsearch"
          />

          {webSiteData?.MULTI_VENDOR == "true" && (
            <select
              id="vendorssearch"
              className="first-search-input"
              style={{ borderLeft: "1px solid var(--secondary-color)", borderRight: "none" }}
              onChange={(e) => setSelectedVendor(e.target.value)}
              value={selectedVendor}
            >
              <option value=''>{t("vendor name")}</option>
              {vendors && vendors?.map(vendor =>
                <option key={vendor._id} value={vendor._id}>{vendor?.firstname + vendor?.lastname}</option>
              )}
            </select>
          )}

          <button className="search-btn" onClick={onChangeSearch}>
            <BsSearch size={18} />
          </button>
        </div>




          <Nav className="noon-user-controls d-flex align-items-md-center flex-column flex-md-row mt-3 mt-md-0" style={{ gap: '15px', padding: '0 10px', marginInlineStart: 'auto' }}>
            {/* Language Switcher */}
            {i18n.language === "en" ? (
              <Nav.Item
                onClick={() => i18n.changeLanguage("ar")}
                style={{ cursor: 'pointer' }}
                className="d-flex align-items-center mb-3 mb-md-0"
              >
                <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                  <div style={{ flexShrink: 0, width: '36px', height: '36px', borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '16px' }}>
                    <i className="fa-solid fa-globe"></i>
                  </div>
                  <div className="d-flex flex-column align-items-start justify-content-center">
                    <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '11px', lineHeight: '1' }}>اللغة</span>
                    <span style={{ color: '#fff', fontSize: '14px', fontWeight: 700, lineHeight: '1.2' }}>عربي</span>
                  </div>
                </div>
              </Nav.Item>
            ) : (
              <Nav.Item
                onClick={() => i18n.changeLanguage("en")}
                style={{ cursor: 'pointer' }}
                className="d-flex align-items-center mb-3 mb-md-0"
              >
                <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                  <div style={{ flexShrink: 0, width: '36px', height: '36px', borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '16px' }}>
                    <i className="fa-solid fa-globe"></i>
                  </div>
                  <div className="d-flex flex-column align-items-start justify-content-center">
                    <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '11px', lineHeight: '1' }}>Language</span>
                    <span style={{ color: '#fff', fontSize: '14px', fontWeight: 700, lineHeight: '1.2' }}>EN</span>
                  </div>
                </div>
              </Nav.Item>
            )}

            {/* User Profile or Login */}
            {userData != "" ? (
              <NavDropdown 
                className="profile-nav-dropdown d-none d-md-flex align-items-center"
                title={
                  <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                    <div style={{
                      flexShrink: 0, width: '36px', height: '36px', borderRadius: '50%',
                      backgroundColor: 'rgba(255,255,255,0.15)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      color: '#fff', fontSize: '16px',
                    }}>
                      <i className="fa-regular fa-user"></i>
                    </div>
                    <div className="d-none d-lg-flex flex-column align-items-start justify-content-center">
                      <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '11px', lineHeight: '1' }}>{t("Welcome")}</span>
                      <span style={{ color: '#fff', fontSize: '14px', fontWeight: 700, maxWidth: '90px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', lineHeight: '1.2' }}>
                        {userData?.firstname || userData?.name || t("account")}
                      </span>
                    </div>
                  </div>
                }
                id="basic-nav-dropdown"
              >
                <div style={{ padding: '4px 0', minWidth: '200px' }}>
                  {userData.role === "admin" ? (
                    <NavDropdown.Item onClick={navProduct} className="py-2">
                      <Link to="/admin/products" style={{ textDecoration: "none", color: 'var(--primary-color)', fontWeight: '600' }}>
                        <i className="fa-solid fa-gauge me-2"></i> {t("control panel")}
                      </Link>
                    </NavDropdown.Item>
                  ) : userData.role === "user" ? (
                    <Fragment>
                      <NavDropdown.Item onClick={() => navigate('/user/profile')} className="py-2">
                        <Link to="/user/profile" style={{ textDecoration: "none", color: '#404553', fontWeight: '600' }}>
                          <i className="fa-regular fa-id-badge me-2"></i> {t("profile")}
                        </Link>
                      </NavDropdown.Item>
                      <NavDropdown.Item onClick={() => navigate('/user/allorders')} className="py-2">
                        <Link to="/user/allorders" style={{ textDecoration: "none", color: '#404553', fontWeight: '600' }}>
                          <i className="fa-solid fa-box-open me-2"></i> {t("orders")}
                        </Link>
                      </NavDropdown.Item>
                      <NavDropdown.Item onClick={() => navigate('/user/favoriteproducts')} className="py-2">
                        <Link to="/user/favoriteproducts" style={{ textDecoration: "none", color: '#404553', fontWeight: '600' }}>
                          <i className="fa-regular fa-heart me-2"></i> {t("Prefered products")}
                        </Link>
                      </NavDropdown.Item>
                      <NavDropdown.Item onClick={() => navigate('/user/addresses')} className="py-2">
                        <Link to="/user/addresses" style={{ textDecoration: "none", color: '#404553', fontWeight: '600' }}>
                          <i className="fa-solid fa-map-location-dot me-2"></i> {t("personal addresses")}
                        </Link>
                      </NavDropdown.Item>
                    </Fragment>
                  ) : (
                    <NavDropdown.Item href="/vendor/profile" className="py-2">
                      <i className="fa-regular fa-id-badge me-2"></i> {t("profile")}
                    </NavDropdown.Item>
                  )}
                  
                  <NavDropdown.Divider />
                  <NavDropdown.Item className="py-2">
                    <Link onClick={logOut} to="/login" style={{ textDecoration: "none", color: '#dc3545', fontWeight: '600' }}>
                      <i className="fa-solid fa-arrow-right-from-bracket me-2"></i> {t("logout")}
                    </Link>
                  </NavDropdown.Item>
                </div>
              </NavDropdown>
            ) : (
              <Nav.Item className="d-none d-md-flex align-items-center">
                <NavLink
                  to="/login"
                  style={{ textDecoration: "none" }}
                  className="d-flex align-items-center"
                >
                  <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                    <div style={{ flexShrink: 0, width: '36px', height: '36px', borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '16px' }}>
                      <i className="fa-regular fa-user"></i>
                    </div>
                    <div className="d-none d-lg-flex flex-column align-items-start justify-content-center">
                      <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '11px', lineHeight: '1' }}>{t("account")}</span>
                      <span style={{ color: '#fff', fontSize: '14px', fontWeight: 700, lineHeight: '1.2' }}>{t("login")}</span>
                    </div>
                  </div>
                </NavLink>
              </Nav.Item>
            )}

            <div className="d-none d-md-block" style={{ width: '1px', height: '24px', backgroundColor: 'rgba(255,255,255,0.2)' }}></div>

            {/* Cart */}
            {(userData === "" && settingsRes?.data?.hasNotLoginCart === true) || userData.role === "user" ? (
              <NavLink
                to={userData === "" ? "/usercart" : "/cart"}
                className="noon-control-item position-relative d-none d-md-inline-flex"
                style={{ textDecoration: "none" }}
                onClick={handleGoogleEvent}
              >
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                  <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                    <i id="global-cart-icon" className="fa-solid fa-cart-shopping" style={{ fontSize: '20px', color: '#fff' }}></i>
                    <span className="noon-cart-badge position-absolute top-0 start-100 translate-middle badge rounded-pill" style={{ backgroundColor: settingsRes?.data?.secondaryColor || '#ff9800', border: '2px solid var(--primary-color)' }}>
                      {userData === "" ? (notLoginNumberOfCartItems || 0) : (res?.numberOfCart || 0)}
                    </span>
                  </div>
                  <b style={{ color: '#fff', fontSize: '14px' }}>{t("cart")}</b>
                </div>
              </NavLink>
            ) : null}

            {/* Learning Tooltip for Admin/Vendor */}
            {((userData.role === "admin" && location.pathname.startsWith('/admin/')) || 
              (userData.role === "vendor" && location.pathname.startsWith('/vendor/'))) && (
              <Nav.Link href={`/${userData.role}/learning`} className="p-0 ms-2">
                <span data-toggle="tooltip" title={t("Go to the educational page")} className="text-light fs-5">
                  <i className="fa-solid fa-circle-question" style={{ color: 'rgba(255,255,255,0.7)' }}></i>
                </span>
              </Nav.Link>
            )}
          </Nav>

        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBarLogin;
